// source: user.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.cloud.UserInfoBasic', null, global);
goog.exportSymbol('proto.cloud.UserInfoDetailed', null, global);
goog.exportSymbol('proto.cloud.UserUpdateInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserUpdateInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UserUpdateInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserUpdateInfo.displayName = 'proto.cloud.UserUpdateInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserInfoDetailed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UserInfoDetailed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserInfoDetailed.displayName = 'proto.cloud.UserInfoDetailed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.UserInfoBasic = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.UserInfoBasic, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.UserInfoBasic.displayName = 'proto.cloud.UserInfoBasic';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserUpdateInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserUpdateInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserUpdateInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserUpdateInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userDefaultProject: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userDefaultProjectWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    userDefaultAccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userDefaultAccountWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    userFirstName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    userFirstNameWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    userLastName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userLastNameWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    userNickname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    userNicknameWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    userPhoneNumber: jspb.Message.getFieldWithDefault(msg, 13, ""),
    userPhoneNumberWasUpdated: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserUpdateInfo}
 */
proto.cloud.UserUpdateInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserUpdateInfo;
  return proto.cloud.UserUpdateInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserUpdateInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserUpdateInfo}
 */
proto.cloud.UserUpdateInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDefaultProject(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserDefaultProjectWasUpdated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDefaultAccount(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserDefaultAccountWasUpdated(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserFirstName(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserFirstNameWasUpdated(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserLastName(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserLastNameWasUpdated(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserNickname(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserNicknameWasUpdated(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPhoneNumber(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserPhoneNumberWasUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserUpdateInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserUpdateInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserUpdateInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserUpdateInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserDefaultProject();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserDefaultProjectWasUpdated();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getUserDefaultAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserDefaultAccountWasUpdated();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getUserFirstName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUserFirstNameWasUpdated();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getUserLastName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserLastNameWasUpdated();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getUserNickname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUserNicknameWasUpdated();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUserPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUserPhoneNumberWasUpdated();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional string user_default_project = 1;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserDefaultProject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserDefaultProject = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool user_default_project_was_updated = 2;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserDefaultProjectWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserDefaultProjectWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string user_default_account = 3;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserDefaultAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserDefaultAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool user_default_account_was_updated = 4;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserDefaultAccountWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserDefaultAccountWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string user_first_name = 7;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool user_first_name_was_updated = 8;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserFirstNameWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserFirstNameWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string user_last_name = 9;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool user_last_name_was_updated = 10;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserLastNameWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserLastNameWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string user_nickname = 11;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool user_nickname_was_updated = 12;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserNicknameWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserNicknameWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string user_phone_number = 13;
 * @return {string}
 */
proto.cloud.UserUpdateInfo.prototype.getUserPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool user_phone_number_was_updated = 14;
 * @return {boolean}
 */
proto.cloud.UserUpdateInfo.prototype.getUserPhoneNumberWasUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserUpdateInfo} returns this
 */
proto.cloud.UserUpdateInfo.prototype.setUserPhoneNumberWasUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserInfoDetailed.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserInfoDetailed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserInfoDetailed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserInfoDetailed.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userDateCreated: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userDateLastModified: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userDefaultProject: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userDefaultAccount: jspb.Message.getFieldWithDefault(msg, 5, ""),
    userEmail: jspb.Message.getFieldWithDefault(msg, 6, ""),
    userEmailVerified: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    userFirstName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userLastName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userNickname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    userPhoneNumber: jspb.Message.getFieldWithDefault(msg, 11, ""),
    userPhoneNumberVerified: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    userPictureUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
    userPictureName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    userNeedsOnboarding: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    userMayCreateAccount: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserInfoDetailed}
 */
proto.cloud.UserInfoDetailed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserInfoDetailed;
  return proto.cloud.UserInfoDetailed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserInfoDetailed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserInfoDetailed}
 */
proto.cloud.UserInfoDetailed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDateCreated(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDateLastModified(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDefaultProject(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserDefaultAccount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserEmailVerified(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserFirstName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserLastName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserNickname(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPhoneNumber(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserPhoneNumberVerified(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPictureUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPictureName(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserNeedsOnboarding(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUserMayCreateAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserInfoDetailed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserInfoDetailed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserInfoDetailed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserInfoDetailed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserDateCreated();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserDateLastModified();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserDefaultProject();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserDefaultAccount();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUserEmailVerified();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getUserFirstName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserLastName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserNickname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUserPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getUserPhoneNumberVerified();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getUserPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUserPictureName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUserNeedsOnboarding();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getUserMayCreateAccount();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_date_created = 2;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserDateCreated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserDateCreated = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_date_last_modified = 3;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserDateLastModified = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserDateLastModified = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_default_project = 4;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserDefaultProject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserDefaultProject = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user_default_account = 5;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserDefaultAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserDefaultAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string user_email = 6;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool user_email_verified = 7;
 * @return {boolean}
 */
proto.cloud.UserInfoDetailed.prototype.getUserEmailVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserEmailVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string user_first_name = 8;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string user_last_name = 9;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string user_nickname = 10;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string user_phone_number = 11;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool user_phone_number_verified = 12;
 * @return {boolean}
 */
proto.cloud.UserInfoDetailed.prototype.getUserPhoneNumberVerified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserPhoneNumberVerified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string user_picture_url = 13;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string user_picture_name = 14;
 * @return {string}
 */
proto.cloud.UserInfoDetailed.prototype.getUserPictureName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserPictureName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool user_needs_onboarding = 15;
 * @return {boolean}
 */
proto.cloud.UserInfoDetailed.prototype.getUserNeedsOnboarding = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserNeedsOnboarding = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool user_may_create_account = 16;
 * @return {boolean}
 */
proto.cloud.UserInfoDetailed.prototype.getUserMayCreateAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.UserInfoDetailed} returns this
 */
proto.cloud.UserInfoDetailed.prototype.setUserMayCreateAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.UserInfoBasic.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.UserInfoBasic.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.UserInfoBasic} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserInfoBasic.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userFirstName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    userLastName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    userNickname: jspb.Message.getFieldWithDefault(msg, 10, ""),
    userPictureUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
    userPictureName: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.UserInfoBasic}
 */
proto.cloud.UserInfoBasic.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.UserInfoBasic;
  return proto.cloud.UserInfoBasic.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.UserInfoBasic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.UserInfoBasic}
 */
proto.cloud.UserInfoBasic.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserFirstName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserLastName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserNickname(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPictureUrl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserPictureName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.UserInfoBasic.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.UserInfoBasic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.UserInfoBasic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.UserInfoBasic.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserFirstName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUserLastName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUserNickname();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUserPictureUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getUserPictureName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_first_name = 8;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string user_last_name = 9;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string user_nickname = 10;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string user_picture_url = 13;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserPictureUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserPictureUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string user_picture_name = 14;
 * @return {string}
 */
proto.cloud.UserInfoBasic.prototype.getUserPictureName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.UserInfoBasic} returns this
 */
proto.cloud.UserInfoBasic.prototype.setUserPictureName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


goog.object.extend(exports, proto.cloud);
